<template>
  <div class="page-container">

    <div class="loading" v-if="!error && !stopData">
      Carregando dados...
    </div>

    <div class="error" v-if="error && !stopData">
      <svg height="1792" viewBox="0 0 1792 1792" width="1792" xmlns="http://www.w3.org/2000/svg">
        <path d="M896 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zm128 1247v-190q0-14-9-23.5t-22-9.5h-192q-13 0-23 10t-10 23v190q0 13 10 23t23 10h192q13 0 22-9.5t9-23.5zm-2-344l18-621q0-12-10-18-10-8-24-8h-220q-14 0-24 8-10 6-10 18l17 621q0 10 10 17.5t24 7.5h185q14 0 23.5-7.5t10.5-17.5z"/>
      </svg>
      Erro ao carregar dados
    </div>
    <template v-if="stopData">
      <DeparturesPage v-if="page === 'default'" :panelConfig="panelConfig" :stopData="stopData" :clock="clock"></DeparturesPage>
      <DeparturesPageCampoGrande v-if="page === '5w71c'" :panelConfig="panelConfig" :stopData="stopData" :clock="clock"></DeparturesPageCampoGrande>
      <DeparturesPageSantaCruzDoSul v-if="page === '33gjz'" :panelConfig="panelConfig" :stopData="stopData" :clock="clock"></DeparturesPageSantaCruzDoSul>
      <DeparturesPageSaoJose v-if="page === '4xwpc'" :panelConfig="panelConfig" :stopData="stopData" :clock="clock"></DeparturesPageSaoJose>
      <DeparturesPageCampinaGrande v-if="page === '54byr'" :panelConfig="panelConfig" :stopData="stopData" :clock="clock"></DeparturesPageCampinaGrande>
      <DeparturesPagePraiana v-if="page === '2uvyb'" :panelConfig="panelConfig" :stopData="stopData" :clock="clock"></DeparturesPagePraiana>
      <DeparturesPageGuarapuava v-if="page === '4tm9q'" :panelConfig="panelConfig" :stopData="stopData" :clock="clock"></DeparturesPageGuarapuava>
      <DeparturesPageContagem v-if="page === '2x19t'" :panelConfig="panelConfig" :stopData="stopData" :clock="clock"></DeparturesPageContagem>
      <DeparturesPageSaoMateus v-if="page === '5f1xa'" :panelConfig="panelConfig" :stopData="stopData" :clock="clock"></DeparturesPageSaoMateus>
      <DeparturesPageFlorianopolis v-if="page === '4pbxo'" :panelConfig="panelConfig" :stopData="stopData" :clock="clock"></DeparturesPageFlorianopolis>
      <DeparturesPageBlumenau v-if="page === '5f1lx'" :panelConfig="panelConfig" :stopData="stopData" :clock="clock"></DeparturesPageBlumenau>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import { decodePanelConfig } from '@/utils';

export default {
  components: {
    DeparturesPage: () => import('@/components/DeparturesPage.vue'),
    DeparturesPageCampoGrande: () => import('@/components/DeparturesPageCampoGrande.vue'),
    DeparturesPageSantaCruzDoSul: () => import('@/components/DeparturesPageSantaCruzDoSul.vue'),
    DeparturesPageSaoJose: () => import('@/components/DeparturesPageSaoJose.vue'),
    DeparturesPageCampinaGrande: () => import('@/components/DeparturesPageCampinaGrande.vue'),
    DeparturesPagePraiana: () => import('@/components/DeparturesPagePraiana.vue'),
    DeparturesPageGuarapuava: () => import('@/components/DeparturesPageGuarapuava.vue'),
    DeparturesPageContagem: () => import('@/components/DeparturesPageContagem.vue'),
    DeparturesPageSaoMateus: () => import('@/components/DeparturesPageSaoMateus.vue'),
    DeparturesPageFlorianopolis: () => import('@/components/DeparturesPageFlorianopolis.vue'),
    DeparturesPageBlumenau: () => import('@/components/DeparturesPageBlumenau.vue'),
  },

  data() {
    return {
      supportedPages: ['5w71c', '33gjz', '4xwpc', '54byr', '2uvyb', '4tm9q', '2x19t', '5f1xa', '4pbxo', '5f1lx'],
      page: 'default',
      panelConfig: null,
      error: false,
      stopData: null,
      clock: null,
      stopTimezone: null,
      serverTimeDiff: 0,
      serverDate: null,
    }
  },

  methods: {
    getCacheKey() {
      return `proximas-partidas-${this.panelConfig.stopIds.join(',')}`;
    },
    getCachedData() {
      try {
        const cacheKey = this.getCacheKey();
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
          const parsed = JSON.parse(cached);
          const maxAge = 10 * 60 * 1000;
          if (Date.now() - parsed.timestamp < maxAge) {
            return parsed.data;
          }
        }
      } catch (e) {
        return null;
      }
      return null;
    },
    saveToCache(data) {
      try {
        const cacheKey = this.getCacheKey();
        localStorage.setItem(cacheKey, JSON.stringify({
          data: data,
          timestamp: Date.now()
        }));
      } catch (e) {
        console.warn('Error saving to cache', e);
      }
    },
    getServerDate(timezone = 'UTC-3') {
      return this.$axios.get(`https://painel.mobilibus.com/v2/api/public/server/time?timezone=${timezone}`)
        .then((response) => {
          if (response.data.currentLocalTime) {
            this.serverDate = {
              unixtime: response.data.currentLocalTime / 1000
            };
            return this.serverDate;
          }
          // INFO: Em caso da API não retornar o que esperamos vamos usar o horário local do device
          return {
            unixtime: Date.now() / 1000
          };
        })
        // INFO: Em caso de erro vamos usar o horário local do device
        .catch(() => ({
          unixtime: Date.now() / 1000
        }));
    },
    loadDepartures() {
      if (!this.stopData) {
        const cachedData = this.getCachedData();
        if (cachedData) {
          this.stopData = JSON.parse(JSON.stringify(cachedData));
          this.calculateMinutesToArrive();
        }
      }

      this.$axios.get(`${Vue.config.API_ENDPOINT}/departures?v=2&stop_hash=${this.panelConfig.stopIds.join(',')}`)
        .then((response) => {
          const stopData = response.data;

          if (!this.stopTimezone) {
            const stopTzOffset = stopData.stops[0].tzOffset;

            if (stopTzOffset < 0) {
              this.stopTimezone = `UTC${stopTzOffset}`;
            } else if (stopTzOffset > 0) {
              this.stopTimezone = `UTC+${stopTzOffset}`;
            } else {
              this.stopTimezone = 'UTC';
            }

            this.getServerDate(this.stopTimezone).then((serverDate) => {
              this.serverTimeDiff = serverDate.unixtime - Date.now() / 1000;
              this.updateClock();
            });
          }

          return stopData;
        })
        .then((stopData) => {
          this.error = false;

          this.stopData = stopData;
          this.stopData.tzOffset = this.stopData.stops[0].tzOffset;
          this.panelConfig.panelHeader = this.panelConfig.panelHeader || this.stopData.stops[0].name;

          const allUniqueTrips = {};
          for (const trip of this.stopData.trips) {
            trip.times = trip.departures.filter((departure) => {
              if (this.panelConfig.showNextDay === false && departure.nextDay) {
                return false;
              }
              return true;
            });
            trip.alerts = this.stopData.alerts.filter(a => a.routeId == trip.routeId);
            trip.alerts.forEach((a, i) => (a.key = `${trip.tripId}-alert-${i}`));

            /**
             * Pode ter viagens com o mesmo ID porém são de pontos diferentes e nesse caso
             * precisamos agrupar as partidas e alertas dessas viagens.
             */
            const uniqueTrip = allUniqueTrips[trip.tripId];
            if (uniqueTrip) {
              uniqueTrip.times = [...uniqueTrip.times, ...trip.times];
              uniqueTrip.alerts = [...uniqueTrip.alerts, ...trip.alerts];
            } else {
              allUniqueTrips[trip.tripId] = trip;
            }
          }
          this.stopData.trips = Object.values(allUniqueTrips).filter((trip) => trip.times.length > 0);
          this.stopData.trips.sort((a, b) => {
            const t1 = a.times[0];
            const t2 = b.times[0];
            const ts1 = (t1.nextDay ? 1 : 0) + t1.time;
            const ts2 = (t2.nextDay ? 1 : 0) + t2.time;
            return ts1.localeCompare(ts2);
          });

          this.calculateMinutesToArrive();
          this.filterDeparturesTimeLimit();

          const processedData = JSON.parse(JSON.stringify(this.stopData));
          this.saveToCache(processedData);
        })
        .catch((error) => {
          console.error('Error loading departures', error);

          if (!this.stopData) {
            const cachedData = this.getCachedData();
            if (cachedData) {
              this.stopData = JSON.parse(JSON.stringify(cachedData));
              this.calculateMinutesToArrive();
              this.error = false;
            } else {
              this.error = true;
              setTimeout(() => {
                this.error = false;
                this.loadDepartures();
              }, 5000);
            }
          } else {
            setTimeout(() => {
              this.loadDepartures();
            }, 5000);
          }
        });
    },
    calculateMinutesToArrive() {
      this.updateClock();
      const currentTime = this.timeToSeconds(this.clock);

      if (this.stopData) {
        this.stopData.trips.forEach(trip => {
          trip.textColor = this.getTextColor(trip.color);

          trip.times.forEach(d => {
            if (!d.nextDay) {
              d.minutes = (this.timeToSeconds(d.time) - currentTime) / 60;
            }
          });
        });

        // force re-render changing the object reference
        this.stopData = JSON.parse(JSON.stringify(this.stopData));
      }
    },

    filterDeparturesTimeLimit() {
      if (this.stopData && this.panelConfig.hoursAheadLimit < 24) {
        const hoursAheadLimit = parseInt(this.panelConfig.hoursAheadLimit);
        const nowHours = this.timeToSeconds(this.clock) / 60 / 60;

        for (let i = 0; i < this.stopData.trips.length; i++) {
          const trip = this.stopData.trips[i];

          for (let j = 0; j < trip.times.length; j++) {
            const dep = trip.times[j];
            const depHours = this.timeToSeconds(dep.time) / 60 / 60;

            if ((depHours - nowHours) > hoursAheadLimit) {
              console.log({ depHours, nowHours, diff: (depHours - nowHours), hoursAheadLimit });
              trip.times.splice(j, 1);
              j--;
            }
          }

          if (trip.times.length === 0) {
            this.stopData.trips.splice(i, 1);
            i--;
          }
        }
      }
    },

    updateClock() {
      /**
       * getTimezoneOffset() valores positivos estão atrás do UTC e valores negativos estão a frente.
       * Por isso precisamos dividir por -60 para termos os valores em -3 ou -4 como estamos acostumados.
       */
      const localTimezoneInHours = new Date().getTimezoneOffset() / -60;
      const timezoneDiffInHours = (localTimezoneInHours - this.stopData.tzOffset) * -1;
      let currentTimestampRaw = Date.now();
      // INFO: Aplica a diferença de horário do servidor
      currentTimestampRaw += this.serverTimeDiff * 1000;
      // INFO: Aplica a diferença do timezone
      currentTimestampRaw += timezoneDiffInHours * 60 * 60 * 1000;
      let currentTimestamp = new Date(currentTimestampRaw);

      if (this.panelConfig.forceTime) {
        const parts = this.panelConfig.forceTime.replace(/(_|-|:)/g, ' ').split(' ');
        parts[1] = parts[1] - 1; // month
        currentTimestamp = Date.UTC(...parts);
      }

      this.clock = currentTimestamp.toLocaleTimeString('pt-BR', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },

    timeToSeconds(time) {
      const parts = time.split(/:/).map(p => parseInt(p));
      return (parts[0] * 60 * 60) + (parts[1] * 60) + parts[2];
    },

    luminance(r, g, b) {
      return ((r * 299) + (g * 587) + (b * 114)) / 1000;
    },

    getTextColor(color) {
      const r = parseInt(color.substr(1, 2), 16);
      const g = parseInt(color.substr(3, 2), 16);
      const b = parseInt(color.substr(5, 2), 16);

      return this.luminance(r, g, b) > 140 ? '#000000' : '#ffffff';
    }
  },

  created() {
    this.page = this.supportedPages.indexOf(this.$route.params.project) >= 0 ? this.$route.params.project : 'default';

    if (this.$route.query.data) {
      this.panelConfig = decodePanelConfig(decodeURIComponent(this.$route.query.data));
    } else {
      this.panelConfig = {
        // INFO: Vai ser setado no loadDepartures, quando tivermos o nome do ponto
        panelHeader: null,
        stopIds: [this.$route.params.stop],
        maxPages: Number(this.$route.query.pages || '3'),
        showNextDay: this.$route.query.showNextDay == 'true',
        showVehicle: this.$route.query.showVehicle == 'true',
        forceTime: this.$route.query.forceTime == 'true',
        hoursAheadLimit: Number(this.$route.query.hoursAheadLimit || '24'),
      };
    }

    this.loadDepartures();

    if (!this.panelConfig.forceTime) {
      this.departuresInterval = setInterval(this.loadDepartures, 30000);
      this.calculateMinutesInterval = setInterval(this.calculateMinutesToArrive, 10000);
      this.clockInterval = setInterval(this.updateClock, 1000);
    }
  },

  destroyed() {
    clearInterval(this.departuresInterval);
    clearInterval(this.calculateMinutesInterval);
    clearInterval(this.clockInterval);
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  font-size: 16px;
}

.loading, .error {
  text-align: center;
  color: #ccc;
  margin-top: 20vh;
}
.error {
  color: #ff9800;

  svg {
    width: 1.2em;
    height: 1.2em;
    vertical-align: bottom;

    path {
      fill: #ff9800;
    }
  }
}

@media only screen and (min-width: 600px) {
  .page-container {
    font-size: 2.7vw;
  }
}

</style>
